// extracted by mini-css-extract-plugin
module.exports = {"subheading":"section_subheading__3BJp_","heading":"section_heading__WSAKW","sectionContainer":"section_sectionContainer__XKg56"};